// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"f3f09aaf","312":"46c24904","489":"b5f99081","623":"d104089f","646":"e7eabbbd","786":"265647a4","787":"d82ae57c"}[chunkId] + ".chunk.js";
};